export enum TransformStage {
  Render = 'render',
  Serilize = 'serilize',
  Save = 'save',
  Clone = 'clone',
  Init = 'init',
  Upgrade = 'upgrade',
}
